export default "__VITE_ASSET__29bacb68__"